import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

import { ApiService, getResponse, } from '../api.service';
import { Company, ProductShort, SelectItem } from '@models';

@Injectable()
export class CompanyService extends ApiService<Company> {

    protected apiGroup: string = 'crm';
	protected apiName: string = 'company';

	constructor(
		public http: HttpClient,
		public translate: TranslateService,
		public confirmationService: ConfirmationService,
		public messageService: MessageService
	) {
		super(http, translate, confirmationService, messageService);
	}

	selectItemArray(): SelectItem[] {
		let array: SelectItem[] = [];

		for(var item of this.items) {
			array.push({
				label: item.name,
				value: item.id
			})
		}

		return array;
	}

	loadItems(reload: boolean = false): Observable<Array<Company>> {

		if(!reload && this.items.length > 0) {
			return  Observable.create(observer => {
				observer.next(this.items);
				observer.complete();
			});
		}
		return this.getAll({
			fields: [
				'id', 'name'
			]
		}).map(data => {
			this.items = data.data;
			/*for(let item of data.data) {
				console.log(item);
			}*/

			return this.items;
		});
	}
    
	/**
	 * getProducts(parameters)
	 * Retrieve list of all products
	 */
	getProducts(companyId: number): Observable<getResponse<ProductShort>> {
        return this.http.get<getResponse<ProductShort>>(
            this.getBaseUrl('get_products', companyId.toString())
        ).retry(this.retries);
    }

}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/services/crm/company.service.ts